import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _toArray from "@babel/runtime/helpers/toArray";
import n from "../platform/index.js";
import p from "../utils.js";
import h from "./isURLSameOrigin.js";
import c from "./cookies.js";
import C from "../core/buildFullPath.js";
import w from "../core/mergeConfig.js";
import S from "../core/AxiosHeaders.js";
import b from "./buildURL.js";
var F = function F(s) {
  var e = w({}, s);
  var l = e.data,
    o = e.withXSRFToken,
    m = e.xsrfHeaderName,
    f = e.xsrfCookieName,
    r = e.headers,
    t = e.auth;
  e.headers = r = S.from(r), e.url = b(C(e.baseURL, e.url), s.params, s.paramsSerializer), t && r.set("Authorization", "Basic " + btoa((t.username || "") + ":" + (t.password ? unescape(encodeURIComponent(t.password)) : "")));
  var i;
  if (p.isFormData(l)) {
    if (n.hasStandardBrowserEnv || n.hasStandardBrowserWebWorkerEnv) r.setContentType(void 0);else if ((i = r.getContentType()) !== !1) {
      var _ref = i ? i.split(";").map(function (u) {
          return u.trim();
        }).filter(Boolean) : [],
        _ref2 = _toArray(_ref),
        a = _ref2[0],
        d = _ref2.slice(1);
      r.setContentType([a || "multipart/form-data"].concat(_toConsumableArray(d)).join("; "));
    }
  }
  if (n.hasStandardBrowserEnv && (o && p.isFunction(o) && (o = o(e)), o || o !== !1 && h(e.url))) {
    var _a = m && f && c.read(f);
    _a && r.set(m, _a);
  }
  return e;
};
export { F as default };
